module.exports = __webpack_public_path__ + "media/images/worktype_role/analista-9828fc558218e7a411942f739446cb9f.png";